<template>
  <div class="layout-box">
    <LayoutHeader></LayoutHeader>
    <div class="secondary-content">
      <div class="pallet-box">
        <div style="position: relative" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.1)">
          <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">托盘新增变化趋势</h3>
          <div id="machartline" style="width: 100%; height: 100%"></div>
        </div>
        <div style="position: relative" v-loading="loading2" element-loading-background="rgba(0, 0, 0, 0.1)">
          <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">江浙加弹开工率</h3>
          <div id="machartline2" style="width: 100%; height: 100%"></div>
        </div>
      </div>
      <div class="pallet-box">
        <div>
          <div style="height: 100%; width: 49%; border-right: 1px solid #374E7F;position: relative" v-loading="loading3" element-loading-background="rgba(0, 0, 0, 0.1)">
            <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">网点出库占比</h3>
            <div id="machartarea" style="width: 100%; height: 100%"></div>
          </div>
          <div style="height: 100%; width: 49%; border-left: 1px solid #374E7F;position: relative" v-loading="loading4" element-loading-background="rgba(0, 0, 0, 0.1)">
            <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">各地区回收数</h3>
            <div id="machartarea2" style="width: 100%; height: 100%; margin-top: 60px"></div>
          </div>
        </div>
        <div style="position: relative" v-loading="loading5" element-loading-background="rgba(0, 0, 0, 0.1)">
          <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">开机率变化趋势</h3>
          <div id="machartline3" style="width: 100%; height: 100%"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "./pallet-header";
import {parseTime} from "../../bll/utils";

export default {
  name: 'PalletIndex',
  props: {
    dataRefresh: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components:{
    LayoutHeader
  },
  data () {
    return {
      loading:true,
      loading2:true,
      loading3:true,
      loading4:true,
      loading5:true,
    }
  },
  mounted () {
    const $this=this
    setTimeout(function () {
      $this.getdata()
    },500)
    $this.dataRefresh.$ons('Refresh', () => {
      $this.getdata()
    })
  },
  methods:{
    getdata(){
      const $this=this
      const url = '/api-portal/palletanalysis/arearecovery';
      $this.$api.post(url, {}, (response) => {
        let datas=response.data||''
        if(datas){
          const datad=datas.data
          let data1=[],data2=[]
          datad.map(val=>{
            data1.push(val.branchName)
            data2.push(val.num)
          })
          $this.drawchartfour(data1,data2)
        }
      })
      const url2 = '/api-portal/palletanalysis/outboundpersent';
      $this.$api.post(url2, {}, (response) => {
        let datas=response.data||''
        if(datas){
          let arr=datas.data.map(val => {
            return {name:val.branchName,value:val.num}
          })
          $this.drawchartthree(arr)
        }
      })
      const url3 = '/api-portal/palletanalysis/palletchange';
      $this.$api.post(url3, {}, (response) => {
        let datas=response.data||''
        if(datas){
          const datad=datas.data
          let data1=[],data2=[],data3=[]
          datad.map(val=>{
            data1.push(val.reportMonth)
            data2.push(val.fdynum)
            data3.push(val.poynum)
          })
          $this.drawchartone(data1,data2,data3)
        }
      })
      const url4 = '/api-portal/palletanalysis/poweronpersent';
      $this.$api.post(url4, {}, (response) => {
        let datas=response.data||''
        if(datas){
          const datad=datas.data
          let data1=[]
          datad.map(val=>{
            data1.push([val.dateStr,val.persent])
          })
          $this.drawchartfive(data1)
        }
      })
      const url5 = '/api-portal/palletanalysis/operatingrate';
      $this.$api.post(url5, {}, (response) => {
        let datas=response.data||''
        if(datas){
          const datad=datas.data
          let data1=[]
          datad.map(val=>{
            data1.push([val.yeardate,val.value,val.date])
          })
          console.log(data1)
          $this.drawcharttwo(data1)
        }
      })
    },
    drawchartone(data1,data2,data3){
      const myEchartst = this.$echarts.init(document.getElementById('machartline'))
      let option = {
        tooltip:{
          show:true,
          trigger: 'axis',
          formatter:function (params) {
            let str = '';
            params.forEach((item, idx) => {
              let vals=item.data>100?(item.data/10000).toFixed(2):item.data
              str += idx != 0? '': item.axisValue+'<br/>'
              str += `${item.marker}${item.seriesName}: ${vals} ${item.data>100?'万':''}`
              str += idx === params.length -1? '': '<br/>'
            })
            return str
          }
        },
        color:['#396AEE','#40D4C6'],
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '14%',
          containLabel: true
        },
        legend: {
          show: true,
          left: 'center',
          top: 20,
          icon:'path://M128 432h768v192H128z',
          textStyle: {
            color: '#AAAAB0'
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            color: '#B6B6BB'
          },
          axisLine:{
            lineStyle:{
              color:'#5788EC'
            }
          },
          data: data1
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show:false,
          },
          axisLine:{
            show:true,
            lineStyle:{
              color:'#252636'
            }
          },
          axisLabel: {
            color: '#B6B6BB',
            formatter: function (params) {
              return parseInt(params/10000)+'万'
            }
          }
        },
        series: [
          {
            data: data2,
            name:'FDY',
            type: 'line',
            smooth: true,
            showSymbol: false,
            areaStyle: {}
          },
          {
            data: data3,
            name:'POY',
            type: 'line',
            smooth: true,
            showSymbol: false,
            areaStyle: {}
          }
        ]
      }
      myEchartst.setOption(option)
      this.loading=false
    },
    drawcharttwo(data){
      const myEchartst = this.$echarts.init(document.getElementById('machartline2'))
      var st = (data[data.length -49])[0]
      var ed = (data[data.length -1])[0]
      let option = {
        tooltip: {
          trigger: 'axis',
          // position: function (pt) {
          //   return [pt[0], '10%'];
          // },
          formatter: function (params) {
            return `${params[0].value[0]}<br>${params[0].marker} 开工率：${params[0].value[1]} %`
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '12%',
          top: '14%',
          containLabel: true
        },
        xAxis: {
          type: 'time',
          boundaryGap: false,
          axisLabel: {
            color: '#B6B6BB',
            formatter: function (params) {
              return parseTime(params,'{y}-{m}-{d}')
            }
          },
          axisLine:{
            lineStyle:{
              color:'#5788EC'
            }
          }
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%'],
          splitLine: {
            show:false,
          },
          max:function (value) {
            return value.max
          },
          axisLine:{
            show:true,
            lineStyle:{
              color:'#555656'
            }
          },
          axisLabel: {
            color: '#B6B6BB'
          }
        },
        dataZoom: [
          {
            type: 'slider',
            borderColor:'#000',
            backgroundColor: 'rgba(47,69,84,0.8)',
            startValue: st,
            endValue: ed
          }
        ],
        series: [
          {
            name: '百分比',
            type: 'line',
            smooth: true,
            showSymbol: false,
            areaStyle: {},
            data: data
          }
        ]
      }
      myEchartst.setOption(option)
      this.loading2=false
    },
    drawchartthree(data){
      const myEchartst = this.$echarts.init(document.getElementById('machartarea'))
      let option = {
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            return `${params.marker}${params.name}<br>${params.seriesName}：${(params.value/10000).toFixed(1)} 万 （${params.percent}%）`
          }
        },
        color:['#2E88FF','#FE8433','#1FD3CD','#6D6DF2','#4CA2DC','#FFB70A','#DB7295','#89A7FA','#34ADA9','#EE6666','#7178BC','#CFA67C','#73C0DE','#5470C6'],
        series: [
          {
            name: '出库数',
            type: 'pie',
            radius: ['37%','65%'],
            top:20,
            data: data,
            label: {
              color:'#B6B6BB',
              formatter:`{b} \n{d}%`,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      myEchartst.setOption(option)
      this.loading3=false
    },
    drawchartfour(data,data1){
      const myEchartst = this.$echarts.init(document.getElementById('machartarea2'))
      let option = {
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function (params) {
            return `${params.marker}${params.name}<br>${params.seriesName}：${(params.value/10000).toFixed(1)} 万 `
          }
        },
        polar: {
          radius: ["5%", "90%"],
          //   center: ["50%", "50%"],
        },
        angleAxis: {
          max: function (value) {
            return Math.ceil(value.max)+600000
          },
          startAngle: 90,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        radiusAxis: {
          type: "category",
          data: data,
          axisLabel: {
            show: true,
            interval:0,
            fontSize:12,
            color:'#B7BCE4',
          },
          // axisTick: {
          //   show: false,
          // },
          // splitLine: {
          //   show: false,
          // },
          // axisLine: {
          //   show: false,
          // },
        },
        series: {
          type: "bar",
          name: '回收数',
          // colorBy: "data",
          barCategoryGap: 3, // 柱形间距
          color: ["#2E88FF"],
          data: data1,
          roundCap: true,
          coordinateSystem: "polar",
          labelLine: {
            show: true,
          },
          normal:{
            color:'#fff'
          },
          emphasis: {
            focus: 'series',
            color:'#ff0'
          }
        },
      }
      myEchartst.setOption(option)
      this.loading4=false
    },
    drawchartfive(data){
      const myEchartst = this.$echarts.init(document.getElementById('machartline3'))
      var st = (data[data.length -49])[0]
      var ed = (data[data.length -1])[0]
      let option = {
        color:['#E76675'],
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            return `${params[0].value[0]}<br>${params[0].marker} 变化趋势百分比：${params[0].value[1]?(params[0].value[1]).toFixed(1):0} %`
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '12%',
          top: '14%',
          containLabel: true
        },
        xAxis: {
          type: 'time',
          boundaryGap: false,
          axisLabel: {
            color: '#B6B6BB',
            formatter: function (params) {
              return parseTime(params,'{y}-{m}-{d}')
            }
          },
          axisLine:{
            lineStyle:{
              color:'#252636'
            }
          }
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%'],
          splitLine: {
            show:false,
          },
          max:function (value) {
            return Math.ceil(value.max)
          },
          axisLine:{
            show:true,
            lineStyle:{
              color:'#555656'
            }
          },
          axisLabel: {
            color: '#B6B6BB'
          }
        },
        dataZoom: [
          {
            type: 'slider',
            borderColor:'#000',
            backgroundColor: 'rgba(47,69,84,0.8)',
            startValue: st,
            endValue: ed
          }
        ],
        series: [
          {
            name: '百分比',
            type: 'line',
            smooth: true,
            showSymbol: true,
            areaStyle: {},
            symbolSize:1,
            label:{
              show:true,
              formatter:function (params) {
                return params.dataIndex%4==0?params.value[1].toFixed(1)+'%':''
              },
              textStyle: {
                color:'#fff'
              }
            },
            data: data
          }
        ]
      }
      myEchartst.setOption(option)
      this.loading5=false
    }
  }
}
</script>

<style scoped>
.layout-box {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1;
  top:0;
  left: 0;
  background: #060614 url("../../assets/bjs.png") no-repeat top/100%;
}

.secondary-content{
  width: 100%;
  height: calc(100% - 20px);
  padding: 0 10px;
  padding-top: 152px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
}

.pallet-box{
  box-sizing: border-box;
  height: 100%;
  width: 50%;
  display: flex;
  flex-direction:column;
  justify-content: space-between;
  align-items: center;
}

.pallet-box>div{
  border: 1px solid #374E7F;
  box-sizing: border-box;
  width: 99.2%;
  height: 49.5%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// src/views/pallet/pallet-analysis.vue